{
    "warning": "WARNING!",
    "message": "Do not enter or paste code that you do not understand.\nUsing this console may allow attackers to impersonate you and steal your information using an attack called Self-XSS."
}
